import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTiktok = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M13.4615 5.5129C13.3452 5.16393 12.993 4.95083 12.6299 5.00975C12.2668 5.06867 12 5.38223 12 5.75007V14.7501C12 15.9927 10.9926 17.0001 9.75 17.0001C8.50736 17.0001 7.5 15.9927 7.5 14.7501C7.5 13.5074 8.50736 12.5001 9.75 12.5001C10.1642 12.5001 10.5 12.1643 10.5 11.7501C10.5 11.3359 10.1642 11.0001 9.75 11.0001C7.67893 11.0001 6 12.679 6 14.7501C6 16.8211 7.67893 18.5001 9.75 18.5001C11.8211 18.5001 13.5 16.8211 13.5 14.7501V8.20786C14.2669 8.92047 15.3473 9.50007 16.75 9.50007C17.1642 9.50007 17.5 9.16428 17.5 8.75007C17.5 8.33585 17.1642 8.00007 16.75 8.00007C15.7781 8.00007 15.0388 7.60087 14.4914 7.08115C13.9312 6.54933 13.5934 5.90846 13.4615 5.5129Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16 21.75C19.1756 21.75 21.75 19.1756 21.75 16V8C21.75 4.82436 19.1756 2.25 16 2.25H8C4.82436 2.25 2.25 4.82436 2.25 8V16C2.25 19.1756 4.82436 21.75 8 21.75H16ZM20.25 16C20.25 18.3472 18.3472 20.25 16 20.25H8C5.65279 20.25 3.75 18.3472 3.75 16V8C3.75 5.65279 5.65279 3.75 8 3.75H16C18.3472 3.75 20.25 5.65279 20.25 8V16Z",
		fill: "currentColor"
	})]
});
export default SvgTiktok;
